import { render } from "./FinishSetup.vue?vue&type=template&id=1a572c78"
import script from "./FinishSetup.vue?vue&type=script&lang=js"
export * from "./FinishSetup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__